/**
 * Parses duration in seconds to hh:mm:ss format
 * hh only shows if duration is more than an hour
 */
const parseTimeDuration = (duration_S: number) => {
	const hours = Math.floor(duration_S / 3600);
	const minutes = Math.floor((duration_S % 3600) / 60);
	const seconds = Math.floor(duration_S % 60);

	const hoursStr = hours > 0 ? `${hours}:` : "";
	const minutesStr = minutes < 10 ? `0${minutes}:` : `${minutes}:`;
	const secondsStr = seconds < 10 ? `0${seconds}` : `${seconds}`;

	return `${hoursStr}${minutesStr}${secondsStr}`;
};
export default parseTimeDuration;
